

export const register = () => {
    if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
            // we will register it after the page complete the load
            navigator.serviceWorker.register("/service-worker.js", { scope: '/APWeb' });
        });
    }
}